import { CurrencyPipe } from "@angular/common"
import { ErrorHandler, NgModule } from "@angular/core"
import { FlexLayoutModule } from "@angular/flex-layout"
import { FormsModule } from "@angular/forms"
import { HttpModule } from "@angular/http"
import { BrowserModule } from "@angular/platform-browser"
import { BrowserAnimationsModule } from "@angular/platform-browser/animations"
import { RouterModule, Routes } from "@angular/router"
import { Md2Module } from "md2"
import { AppComponent } from "./app.component"
import { AppMaterialModule } from "./app-material.module"
import { CopyDirective } from "./copy.directive"
import { LoggerService } from "./logger.service"
import { MerchantInfoComponent } from "./merchant-info/merchant-info.component"
import { NamePipe } from "./name.pipe"
import { NewlinesPipe } from "./newlines.pipe"
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component"
import { ReferralMagicMerchantComponent } from "./referral-magic/merchant/merchant.component"
import { ReferralMagicEmailModalComponent } from "./referral-magic/merchant-advocate/email-modal/email-modal.component"
import { ReferralMagicMerchantAdvocateComponent } from "./referral-magic/merchant-advocate/merchant-advocate.component"
import { ReferralMagicShareModalComponent } from "./referral-magic/merchant-advocate/share-modal/share-modal.component"
import { ReferralMagicSuccessModalComponent } from "./referral-magic/merchant-advocate/success-modal/success-modal.component"
import { ReferralMagicMerchantTermsComponent } from "./referral-magic/merchant-terms/merchant-terms.component"
import { ReferralMagicReferralsTableComponent } from "./referral-magic/referrals-table/referrals-table.component"
import { ReferralMagicRewardsTableComponent } from "./referral-magic/rewards-table/rewards-table.component"

declare global {
  interface Navigator {
    share(object: Object): any
  }
}

const appRoutes: Routes = [
  { path: ":merchant_slug", component: ReferralMagicMerchantComponent },
  { path: ":merchant_slug/terms", component: ReferralMagicMerchantTermsComponent },
  { path: ":merchant_slug/:advocate_identifier", component: ReferralMagicMerchantAdvocateComponent },
  { path: ":merchant_slug/:advocate_identifier/:token", component: ReferralMagicMerchantAdvocateComponent },
  { path: "**", component: PageNotFoundComponent }
]

@NgModule({
  declarations: [
    AppComponent,
    MerchantInfoComponent,
    PageNotFoundComponent,
    ReferralMagicMerchantComponent,
    ReferralMagicMerchantAdvocateComponent,
    ReferralMagicMerchantTermsComponent,
    ReferralMagicReferralsTableComponent,
    ReferralMagicRewardsTableComponent,
    ReferralMagicEmailModalComponent,
    ReferralMagicSuccessModalComponent,
    ReferralMagicShareModalComponent,

    CopyDirective,

    NamePipe,
    NewlinesPipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    Md2Module.forRoot(),
    AppMaterialModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    RouterModule.forRoot(appRoutes)
  ],
  providers: [
    CurrencyPipe,
    {
      provide: ErrorHandler,
      useClass: LoggerService
    }
  ],
  entryComponents: [
    ReferralMagicEmailModalComponent,
    ReferralMagicSuccessModalComponent,
    ReferralMagicShareModalComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/app.module.ts